import FeatureGates from '@atlaskit/feature-gate-js-client';

export enum FeatureGate {
  // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/migrate_cloud_user_to_agg_user_query
  MIGRATE_CLOUD_USER_TO_AGG_USER_QUERY = 'migrate_cloud_user_to_agg_user_query',
  // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/enable_en_zz_i18n_locale
  ENABLE_EN_ZZ_I18N_LOCALE = 'enable_en_zz_i18n_locale',
}

export const checkFeatureGate = (key: FeatureGate) => {
  return FeatureGates.initializeCompleted() && FeatureGates.checkGate(key);
};
